(function () {
  function getVariantId(item) {
    return Number(item?.variant_id ?? item?.product_variant_id ?? item?.variant?.id ?? 0);
  }
  function getLineKey(item) {
    return String(item?.key ?? item?.id ?? getVariantId(item) ?? '');
  }
  function isPromoItem(it) {
    return !!(it?.properties?._yk_xsell_link || it?.properties?._yk_xsell_bundle === '1');
  }
  function getPromoLinkId(it) {
    return Number(it?.properties?._yk_xsell_link || 0);
  }
  function getItemName(it) {
    return it?.product_title || it?.title || '';
  }

  let _ykBulkCleanup = false;
  const withBulkCleanup = async (fn) => {
    _ykBulkCleanup = true;
    try {
      try {
        window._promoAutoCleanup = true;
      } catch (_) {}
      return await fn();
    } finally {
      _ykBulkCleanup = false;
      try {
        window._promoAutoCleanup = false;
      } catch (_) {}
    }
  };

  function showXsellRemoveConfirm(_triggerOrPromoItem, promosToList) {
    return new Promise((resolve) => {
      const wrap = document.getElementById('yk-xsell-remove-confirm');
      const list = document.getElementById('yk-xsell-remove-list');
      const btnOk = document.getElementById('yk-xsell-remove-confirm-btn');
      const btnCancel = document.getElementById('yk-xsell-remove-cancel');

      if (!wrap || !list || !btnOk || !btnCancel) {
        resolve(true);
        return;
      }

      const promoNames = [...new Set(promosToList.map(getItemName).filter(Boolean))];
      console.log(promoNames);
      const count = promoNames.length;
      const label = count === 1 ? 'produkt' : 'produkty';
      list.innerHTML = `<span class="font-normal">${label}</span> ${promoNames.join(', ')}`;

      wrap.classList.remove('hidden');

      const close = (val) => {
        wrap.classList.add('hidden');
        btnOk.removeEventListener('click', onOk);
        btnCancel.removeEventListener('click', onCancel);
        resolve(val);
      };
      const onOk = () => close(true);
      const onCancel = () => close(false);

      btnOk.addEventListener('click', onOk);
      btnCancel.addEventListener('click', onCancel);
    });
  }

  function reenableMinusButtons() {
    try {
      document
        .querySelectorAll('.rebuy-cart__flyout-item-quantity-widget-button[disabled]')
        .forEach((btn) => btn.removeAttribute('disabled'));
    } catch (_) {}
  }

  let patched = false;
  function patchRemoveOnce() {
    try {
      const SC = window.Rebuy?.SmartCart;
      if (!SC || !SC.removeItem || patched) return;

      const orig = SC.removeItem.bind(SC);

      SC.removeItem = async function ykConfirmingRemove(item, ...rest) {
        if (_ykBulkCleanup) {
          return orig(item, ...rest);
        }

        try {
          const items = window.Rebuy?.SmartCart?.cart?.items || [];

          const isTrigger = item && !isPromoItem(item);
          if (isTrigger) {
            const linkVid = getVariantId(item);

            const remainingTriggersQty = items
              .filter((it) => !isPromoItem(it) && getVariantId(it) === linkVid && getLineKey(it) !== getLineKey(item))
              .reduce((n, it) => n + Number(it.quantity || 1), 0);

            if (remainingTriggersQty > 0) {
              return orig(item, ...rest);
            }

            const linkedPromos = items.filter((it) => isPromoItem(it) && getPromoLinkId(it) === linkVid);

            if (linkedPromos.length > 0) {
              const ok = await showXsellRemoveConfirm(item, linkedPromos);
              if (!ok) return;

              return withBulkCleanup(async () => {
                const res = await orig(item, ...rest);
                for (const promo of [...linkedPromos].reverse()) {
                  try {
                    await orig(promo, ...rest);
                  } catch (_) {}
                }
                return res;
              });
            }
          }

          const isPromoBundle = item?.properties?._yk_xsell_bundle === '1';
          const gid = item?.properties?._yk_xsell_bundle_group || null;

          if (isPromoBundle && gid) {
            const siblings = items.filter(
              (it) =>
                it?.properties?._yk_xsell_bundle === '1' &&
                it?.properties?._yk_xsell_bundle_group === gid &&
                getLineKey(it) !== getLineKey(item)
            );

            if (siblings.length > 0) {
              const ok = await showXsellRemoveConfirm(item, siblings);
              if (!ok) return;

              return withBulkCleanup(async () => {
                const res = await orig(item, ...rest);
                for (const sib of [...siblings].reverse()) {
                  try {
                    await orig(sib, ...rest);
                  } catch (_) {}
                }
                return res;
              });
            }
          }
        } catch (_) {}

        return orig(item, ...rest);
      };

      patched = true;
    } catch (e) {
      console.warn('[XSell] removeItem confirm patch failed', e);
    }
  }

  let patchedDecrease = false;
  function patchDecreaseOnce() {
    try {
      const SC = window.Rebuy?.SmartCart;
      if (!SC || !SC.decreaseItem || patchedDecrease) return;

      const origDecrease = SC.decreaseItem.bind(SC);
      const doRemove = (it, ...rest) => (SC.removeItem ? SC.removeItem(it, ...rest) : origDecrease(it, ...rest));

      SC.decreaseItem = async function ykConfirmingDecrease(item, ...rest) {
        if (_ykBulkCleanup) {
          return origDecrease(item, ...rest);
        }
        try {
          const qty = Number(item?.quantity || 1);
          if (qty > 1) {
            return origDecrease(item, ...rest);
          }

          const items = window.Rebuy?.SmartCart?.cart?.items || [];

          const isTrigger = item && !isPromoItem(item);
          if (isTrigger) {
            const linkVid = getVariantId(item);

            const remainingTriggersQty = items
              .filter((it) => !isPromoItem(it) && getVariantId(it) === linkVid && getLineKey(it) !== getLineKey(item))
              .reduce((n, it) => n + Number(it.quantity || 1), 0);
            if (remainingTriggersQty > 0) {
              // normalnie zmniejsz do 0 bez confirm
              return origDecrease(item, ...rest);
            }

            const linkedPromos = items.filter((it) => isPromoItem(it) && getPromoLinkId(it) === linkVid);

            if (linkedPromos.length > 0) {
              const ok = await showXsellRemoveConfirm(item, linkedPromos);
              if (!ok) {
                reenableMinusButtons();
                return;
              }
              return withBulkCleanup(async () => {
                const res = await doRemove(item, ...rest); // trigger -> 0
                for (const promo of [...linkedPromos].reverse()) {
                  try {
                    await doRemove(promo, ...rest);
                  } catch (_) {}
                }
                return res;
              });
            }
          }

          const isPromoBundle = item?.properties?._yk_xsell_bundle === '1';
          const gid = item?.properties?._yk_xsell_bundle_group || null;

          if (isPromoBundle && gid) {
            const siblings = items.filter(
              (it) =>
                it?.properties?._yk_xsell_bundle === '1' &&
                it?.properties?._yk_xsell_bundle_group === gid &&
                getLineKey(it) !== getLineKey(item)
            );

            if (siblings.length > 0) {
              const ok = await showXsellRemoveConfirm(item, siblings);
              if (!ok) {
                reenableMinusButtons();
                return;
              }
              return withBulkCleanup(async () => {
                const res = await doRemove(item, ...rest);
                for (const sib of [...siblings].reverse()) {
                  try {
                    await doRemove(sib, ...rest);
                  } catch (_) {}
                }
                return res;
              });
            }
          }
        } catch (_) {}

        return origDecrease(item, ...rest);
      };

      patchedDecrease = true;
    } catch (e) {
      console.warn('[XSell] decreaseItem confirm patch failed', e);
    }
  }

  document.addEventListener('rebuy:ready', () => {
    patchDecreaseOnce();
    patchRemoveOnce();
  });
  document.addEventListener('rebuy:smartcart.show', () => {
    patchDecreaseOnce();
    patchRemoveOnce();
  });
})();

window.ykFindBundleMate = function (item) {
  try {
    if (item?.properties?._yk_xsell_bundle !== '1') return null;
    const gid = item?.properties?._yk_xsell_bundle_group || null;
    if (!gid) return null;

    const cartItems = window.Rebuy?.SmartCart?.cart?.items || [];
    const mate = cartItems.find(
      (it) =>
        it?.properties?._yk_xsell_bundle === '1' &&
        it?.properties?._yk_xsell_bundle_group === gid &&
        (it.key ?? it.id) !== (item.key ?? item.id)
    );
    return mate || null;
  } catch (e) {
    return null;
  }
};

window.ykFindTriggerByVariant = function (variantId) {
  try {
    if (!variantId) return null;
    const cartItems = window.Rebuy?.SmartCart?.cart?.items || [];
    return (
      cartItems.find(
        (it) =>
          Number(it.variant_id ?? it.product_variant_id ?? it.variant?.id) === Number(variantId) &&
          !(it?.properties?._yk_xsell_bundle === '1' || it?.properties?._yk_xsell_link)
      ) || null
    );
  } catch (e) {
    return null;
  }
};

window.ykBannerCopy = function (item) {
  let triggerVariantId = Number(item?.properties?._yk_xsell_link || 0);
  let trigger = triggerVariantId ? window.ykFindTriggerByVariant(triggerVariantId) : null;

  if (!trigger) {
    const mate = window.ykFindBundleMate(item);
    if (mate) {
      triggerVariantId = Number(mate?.properties?._yk_xsell_link || 0);
      trigger = triggerVariantId ? window.ykFindTriggerByVariant(triggerVariantId) : null;
    }
  }

  const triggerName = trigger?.product_title || trigger?.title || '';

  return triggerName ? `Produkt w pakiecie z ${triggerName}` : '';
};
